// extracted by mini-css-extract-plugin
export var black = "_32-6";
export var brand = "_32-1";
export var ddefault = "_32-0";
export var error = "_32-3";
export var gray = "_32-2";
export var highContrast = "_32-8";
export var outline = "_32-7";
export var success = "_32-5";
export var warning = "_32-4";